import React from 'react';
import ReactDom from 'react-dom';

import ErrorBoundary from '../Components/ErrorBoundary/index.jsx';
import PagedData from '../Components/PagedData/index.jsx';
import ShowLocked from '../Components/ShowLocked/index.jsx';
import TaxonomyTermsList from '../Components/TaxonomyTermsList/index.jsx';

import API from '../Services/TaxonomyTerms/index.jsx';


export default function(document) {
  var element = document.getElementById('cs-taxonomy-terms');

  if (element) {
    var term = element.dataset.term;
    var showLocked = Boolean(element.dataset.showLocked);
    var showLockedUi = Boolean(element.dataset.showLockedUi);

    var api = new API(term);
    api.showLocked(showLocked);

    var WrappedComponent = PagedData(TaxonomyTermsList, api);

    var output = [];
    if (showLockedUi) {
      output.push(
        <ShowLocked key="show-locked" showLocked={showLocked} apiService={api} />
      );
    }
    output.push(
      <WrappedComponent key="component" />
    );

    ReactDom.render(
      <ErrorBoundary>
        {output}
      </ErrorBoundary>,
      element
    );
  }
};

